import Emitter from "./Emitter";

export default class SoundOff extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: "soundOff" });
    }

    SPINGAMES_handler() {
        this.emitTop({ event: "volume", action: false });
        this.emitParent({ event: "volume", action: false });
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('sound')) {
            let data = {
                _type: "ucip.sound.g2wSoundUpdateNotification",
                mute: true,
                level: 100
            }
            this.emitParent(JSON.stringify(data));
        }
    }

    POKERSTARS_handler() {
        const dataForXc = {
            "msgId":"rg2xcPropertiesUpdated",
            "soundEnabled": false,
        };

        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify(dataForXc), "*");
        }
    }

    LNWOGS_handler() {
        this.gb.wallet.soundOff();
    }

    _default() {
        this.emitParent({ wpgaction: "soundOff.parent" });
        this.emitTop({ wpgaction: "soundOff" });
        this.emitiOS({ wpgaction: "soundOff" });
    }
}
